
const url = "https://prod-admin.onedash.com"

// const url = "localhost:8080"
module.exports = url;